var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoKry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 155,
    viewBox: "0 0 256 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 155,
    fill: "url(#paint0_linear_858:19)",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.491 44.9429L209.882 96.4338L192.47 44.9429H162.514L192.211 122.734C190.33 126.749 184.593 128.588 175.539 128.588C168.592 128.588 163.238 127.72 157.015 125.404V151.163C163.672 153.479 170.184 154.347 176.696 154.347C206.363 154.347 221.413 135.534 232.846 105.723L256 44.9429H227.491Z",
    fill: "#002845"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.679 57.6156V44.9429H93.0515V123.089H120.837V85.3429C126.291 74.3345 133.449 69.9785 145.583 69.9785C149.056 69.9785 151.227 70.4127 154.7 71.5704V44.9429C151.806 44.2194 149.78 43.9299 146.162 43.9299C133.813 43.9299 126.531 48.1267 119.679 57.6156Z",
    fill: "#002845"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9084 44.9429H54.1232C54.7021 62.4172 46.3361 71.3837 27.7852 71.5704V16H0V123.089H27.7852V96.4613C31.7981 96.4507 35.8049 96.146 39.7733 95.5496L53.5444 123.089H85.2369L64.2706 85.5831C75.4802 76.8033 81.5076 62.957 81.9084 44.9429Z",
    fill: "#002845"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_858:19",
    x1: 128,
    y1: 0,
    x2: 128,
    y2: 155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKry);
export default __webpack_public_path__ + "static/media/logo-kry.0ade73b45afc42e051e7b29d37310aa9.svg";
export { ForwardRef as ReactComponent };